import { useAxios } from 'src/hooks/use-axios';

export function useDocumentWithdraw() {
  return useAxios(
    (axios, baseConfig, url: string) =>
      axios.request({
        ...baseConfig,
        method: 'DELETE',
        url,
      }),
    { neededOnPageLoad: false }
  );
}

export type DocumentWithdrawRequest = ReturnType<typeof useDocumentWithdraw>;
